import { TFunction } from 'i18next'
import type { DataTableColumn } from '@/components/ui/data-table-customized'
import {
    createDateFormatter,
    createOptionsFormatter,
    createCurrencyFormatter,
    OptionItem,
} from '@/components/ui/data-table-customized'
import { CustomerCreditTransaction } from '../../types'
import { CREDIT_TRANSACTION_TYPE } from '../../constants'
import { TRANSACTION_STATUS } from '@/modules/Invoice/constants'

// ============================================================================
// Column Configuration
// ============================================================================

/**
 * Column configuration for Credit Transactions table
 * Sortable fields: TBD (check backend API documentation)
 */
export const getCreditTransactionColumns = (
    t: TFunction
): DataTableColumn<CustomerCreditTransaction>[] => [
    {
        key: 'credit_transaction_id',
        title: 'ID',
        width: 100,
        sortable: false,
    },
    {
        key: 'employee_name',
        title: t('employee_name'),
        width: 150,
        sortable: false,
    },
    {
        key: 'credit_name',
        title: t('credit_name'),
        width: 180,
        sortable: false,
    },
    {
        key: 'credit_transaction_amount',
        title: t('credit_transaction_amount'),
        width: 150,
        sortable: false,
        cellClassName: 'text-right',
        formatter: createCurrencyFormatter({
            currency: 'VND',
        }),
    },
    {
        key: 'credit_transaction_note',
        title: t('credit_transaction_note'),
        width: 300,
        sortable: false,
    },
    {
        key: 'credit_transaction_type',
        title: t('credit_transaction_type'),
        width: 180,
        sortable: false,
        formatter: createOptionsFormatter({
            options: CREDIT_TRANSACTION_TYPE(t) as OptionItem[],
        }),
    },
    {
        key: 'credit_transaction_status',
        title: t('status'),
        width: 180,
        sortable: false,
        formatter: createOptionsFormatter({
            options: TRANSACTION_STATUS(t) as OptionItem[],
        }),
    },
    {
        key: 'created_at',
        title: t('created_at'),
        width: 150,
        sortable: false,
        formatter: createDateFormatter({
            format: 'HH:mm DD/MM/YYYY',
        }),
    },
]
